import React, { useEffect, useRef, useState } from "react";
import { KLineChartPro } from "@klinecharts/pro";
import "@klinecharts/pro/dist/klinecharts-pro.css";
import clsx from "clsx";
import classes from "./Chart.module.css";
import PeriodDropdown from "../PeriodDropdown/PeriodDropdown";
import { Button, Input } from "components/common";
import CurrencyDropdown from "../CurrencyDropdown/CurrencyDropdown";
const currencies = [{ 
  name: "Binance Smart Chain",
  ticker: "BSC",
  networkType: "EVM",
  logo: "https://assets.coingecko.com/coins/images/828/small/binance-coin-logo.png?1619633471",
  id: "bsc",
  chain_id: 56,
},
];

class DummyDataFeed {
  constructor() {
    this._dataCache = {};
  }

  async searchSymbols() {
    return [
      {
        ticker: "DUMMY-PAIR",
        name: "Dummy Trading Pair",
        shortName: "DUMMY",
        market: "dummy",
        exchange: "Dummy Exchange",
        priceCurrency: "USD",
        type: "crypto",
        logo: "",
      },
    ];
  }

  async getHistoryKLineData(symbol, period, from, to) {
    const cacheKey = `${symbol.ticker}-${period.multiplier}-${period.timespan}-${from}-${to}`;

    if (this._dataCache[cacheKey]) {
      return this._dataCache[cacheKey];
    }

    // Generate dummy data
    const dataPoints = 200;
    const timeRange = to - from;
    const interval = timeRange / dataPoints;

    let currentPrice = 100 + Math.random() * 50; // Start between 100-150
    const data = [];

    for (let i = 0; i < dataPoints; i++) {
      const timestamp = from + i * interval;
      const open = currentPrice;
      const volatility = 0.5 + Math.random() * 2; // Random volatility factor

      // Generate random price movement
      const changePercent = (Math.random() - 0.5) * volatility;
      currentPrice = open * (1 + changePercent / 100);

      const high = Math.max(open, currentPrice) * (1 + Math.random() * 0.005);
      const low = Math.min(open, currentPrice) * (1 - Math.random() * 0.005);
      const close = currentPrice;
      const volume = 1000 + Math.random() * 9000; // Random volume between 1000-10000

      data.push({
        timestamp,
        open,
        high,
        low,
        close,
        volume,
      });
    }

    this._dataCache[cacheKey] = data;
    return data;
  }

  subscribe() {
    // No real-time data for dummy feed
  }

  unsubscribe() {
    // No real-time data for dummy feed
  }
}

const TradingChart = ({
  PERIODS,
  handleAnalyse,
  contactAddress,
  setContactAddress,
  showCurrencyDropdown,
  setShowCurrencyDropdown,
  selectedCurrency,
  setSelectedCurrency,
  selectedPeriod,
  setSelectedPeriod,
  showPeriodDropdown,
  setShowPeriodDropdown,
}) => {
 
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);

  // Update chart when period changes
  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.setPeriod(selectedPeriod);
    }
  }, [selectedPeriod]);

  useEffect(() => {
    // Clear the chart container before creating a new instance
    if (chartRef.current && chartContainerRef.current) {
      chartContainerRef.current.innerHTML = "";
      chartRef.current = null;
    }

    // Initialize chart
    chartRef.current = new KLineChartPro({
      container: chartContainerRef.current,
      theme: "dark",

      locale: "en",
      symbol: {
        drawingBarVisible: true,
        exchange: "Dummy Exchange",
        market: "crypto",
        name: "Dummy Trading Pair",
        shortName: selectedCurrency,
        ticker: selectedCurrency,
        priceCurrency: "USD",
        type: "crypto",
      },
      period: selectedPeriod,
      periods: PERIODS,
      datafeed: new DummyDataFeed(),
    });

    // Cleanup on unmount
    return () => {
      if (chartRef.current && chartContainerRef.current) {
        chartContainerRef.current.innerHTML = "";
        chartRef.current = null;
      }
    };
  }, [selectedCurrency]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <Input
          placeholder="Enter contract address"
          value={contactAddress}
          setValue={setContactAddress}
          className={classes.input}
        />{" "}
        <CurrencyDropdown
          isActive={showCurrencyDropdown}
          setIsActive={setShowCurrencyDropdown}
          items={currencies}
          selectedValue={selectedCurrency}
          setSelectedValue={setSelectedCurrency}
          onSelect={(selected) => {
            setSelectedCurrency(selected);
          }}
        />
        <PeriodDropdown
          isActive={showPeriodDropdown}
          setIsActive={setShowPeriodDropdown}
          items={PERIODS}
          selectedValue={selectedPeriod}
          setSelectedValue={setSelectedPeriod}
          onSelect={(selected) => {
            setSelectedPeriod(selected);
          }}
        />
        <Button onClick={() => {
          handleAnalyse()
        }} className={classes.analysisButton}>
          Analyze
        </Button>
      </div>

      <div ref={chartContainerRef} className={clsx(classes.chart)} />
    </div>
  );
};

export default TradingChart;
